import Section from "@/components/Section2";
import { LandingEntity } from "@/domain";

export const FirstSection = ({ info }: { info: LandingEntity }) => {
  return (
    <Section className="bg-bgLightBlue">
      <div className="flex flex-col gap-6 py-10 tablet:gap-10 tablet:py-12 desktop:max-w-xxl desktop:flex-row desktop:items-center desktop:justify-center desktop:gap-8 desktop:py-16">
        <div className="h-full space-y-5 text-primaryText tablet:space-y-6 desktop:space-y-8">
          <h1
            className="text-header3 tablet:text-header2 desktop:text-header1"
            dangerouslySetInnerHTML={{ __html: info.title }}
          ></h1>
          <div
            className="space-y-4 text-textBody desktop:space-y-5 desktop:text-textMedium"
            dangerouslySetInnerHTML={{ __html: info.text }}
          ></div>
        </div>

        <img
          src="/images/about-us-containers.jpeg"
          className="h-52 w-full rounded-lg object-cover tablet:h-[458px] desktop:h-[328px] desktop:w-[504px]"
        />
      </div>
    </Section>
  );
};
